import { focusManager } from "@tanstack/react-query";
let lastActivityAt = Date.now();
let listening = false;
let foreground = true;

function markActivity() {
  lastActivityAt = Date.now();
}

function ensureActivityTracking() {
  if (listening || typeof window === "undefined") return;
  listening = true;
  for (const eventName of ["pointerdown", "keydown", "scroll", "focus"]) {
    window.addEventListener(eventName, markActivity, { passive: true });
  }
  window.addEventListener('blur', () => { foreground = false; });
  window.addEventListener('focus', () => { foreground = true; markActivity(); focusManager.onFocus(); });
  document.addEventListener("visibilitychange", markActivity, { passive: true });
}

export function pollingInterval(activeMs: number, idleMs = 30_000, hiddenMs = 60_000): number | false {
  ensureActivityTracking();
  if (typeof document !== "undefined" && document.visibilityState === "hidden") return false;
  void hiddenMs;
  return !foreground || Date.now() - lastActivityAt >= 60_000 ? Math.max(30_000, idleMs) : Math.max(5_000, activeMs);
}

export function adaptivePolling(activeMs: number, idleMs = 30_000, hiddenMs = 60_000) {
  return () => pollingInterval(activeMs, idleMs, hiddenMs);
}

// A visible monitoring screen stays live even while the user only watches it.
// 261 supersedes that policy: idle monitoring now shares the 30-second cadence.
export function monitoringPolling(intervalMs: number, hiddenMs = 60_000) {
  return adaptivePolling(intervalMs, 30_000, hiddenMs);
}

export function resetPollingActivityForTests(value = Date.now()) {
  lastActivityAt = value;
  foreground = true;
}
